import React,{useEffect} from "react";
import { dataService } from "../services/data.services";
// import { pushImageToS3 } from "./pushImageToS3";
import { Storage } from 'aws-amplify';
// import { downloadBlob, downloadS3Object } from "./S3DownloadHook";
import uuid from "react-uuid";


async function S3UploadHook(file,path,setprogressCount) {
    const body = {
        "content_type":"image/*",
        "file_path":path,
        "file_name": file.name
    }
    const key = `${path}/${uuid()}/${file.name}`;
    
    try {
        const result = await Storage.put(key,file, {
            contentType: file.type,
            level:'public',
            acl: 'public-read',
            progressCallback(progress) {
                if (typeof setprogressCount === 'function') setprogressCount(parseInt((progress.loaded / progress.total) * 100));
            }
                
        },);
        // downloadS3Object(result.key) //Download example
        return result.key
    } catch (error) {
        console.log(error)

    }
   
}

export default S3UploadHook;